import axios from 'axios';
import { wait } from '@/FreeTrial/helpers.js';

export const POLL_INTERVAL_MS = 3000;
// Provisioning normally finishes in 30-90s; past this the page falls back to "check your email"
// while the job keeps working server-side.
export const POLL_TIMEOUT_MS = 3 * 60 * 1000;
// Individual polls fail for mundane reasons (deploy, network blip); only a run of failures means
// the outcome is genuinely unknown.
export const MAX_CONSECUTIVE_FAILURES = 5;

const failedResult = (errorCode) => ({ status: 'failed', subscriptionId: null, errorCode });

// Resolves with { status: 'complete' | 'failed' | 'timeout', subscriptionId, errorCode }.
export default async (commit, getters) => {
    const provisioningId = getters.provisioningId;
    const deadline = Date.now() + POLL_TIMEOUT_MS;
    let consecutiveFailures = 0;

    while (Date.now() < deadline) {
        try {
            const { data } = await axios.get(`/api/v1/subscription/trial/${encodeURIComponent(provisioningId)}`);
            consecutiveFailures = 0;

            if (data.status === 'complete') {
                commit('updateChargebeeInfo', { subscriptionId: data.subscriptionId });

                return data;
            }

            if (data.status === 'failed') {
                return failedResult(data.errorCode || window.constants.errorCodes.generalError);
            }
        } catch (error) {
            consecutiveFailures += 1;

            if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
                window.Sentry.logError(error, { provisioningId, consecutiveFailures });

                return failedResult(window.constants.errorCodes.generalError);
            }
        }

        await wait(POLL_INTERVAL_MS);
    }

    return { status: 'timeout', subscriptionId: null, errorCode: null };
};
